import React, {useState} from "react";
import MainForm from "./MainForm";
import VerifyMobileForm from "./VerifyMobileForm";
import {DEBUG} from '../../../environment';

const CredentialsForm = () => {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);

  const toggleModal = () => {
    setModalOpen(!isModalOpen)
  }

  const translateErrors = errorMessage => {
    console.log(errorMessage)

    switch (errorMessage) {
      case "must be of string type":
        return "Il dato inserito deve essere alfanumerico";
      case "required field":
        return "Il campo è obbligatorio";
      case "Wrong token":
        return "Il codice inserito è errato";
    }

    return errorMessage;
  }

  return (
    <>
      <MainForm
        showAutocompleteButton={DEBUG}
        loading={loading}
        setLoading={setLoading}
        setMobile={setMobile}
        toggleModal={toggleModal}
        translateErrors={translateErrors}
        mobileVerified={mobileVerified}
      />
      <VerifyMobileForm
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        loading={loading}
        setLoading={setLoading}
        mobile={mobile}
        setMobileVerified={setMobileVerified}
        translateErrors={translateErrors}
      />
    </>
  )
}

export default CredentialsForm;